declare namespace $ {

	export class $company_template_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map